//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import DeviceInfoList from "./DeviceInfoList";
export default {
  components: {
    DeviceInfoList: DeviceInfoList
  },
  data: function data() {
    return {
      tabKeys: "3"
    };
  },
  created: function created() {
    this.tabKeys = "3";
  },
  computed: {},
  methods: {}
};